var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard__container"},[_c('img',{staticClass:"wizard__logo",attrs:{"src":require("@/assets/img/99icon_black.svg"),"alt":"99 Empresas"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }